import { isNumeric } from ".";
import BigNumber from "bignumber.js";

export function formatAddress(address) {
  return address.slice(0, 6) + "..." + address.slice(-4);
}
export function formatPrice(price) {
  if (price < 1e6) return numberWithCommas(Number(price.toFixed(4)));
  if (price < 1e15) {
    const suffixes = ["", "K", "M", "B", "T"];
    const suffixNum = Math.floor((("" + parseInt(price)).length - 1) / 3);
    let shortValue = parseFloat((price / Math.pow(1000, suffixNum)).toFixed(1));
    return shortValue + suffixes[suffixNum];
  }
  return BigNumber(price).toExponential(1);
}

/**
 * Compact large number
 * @param {*} n The number
 * @param {Number} fractionDigits Number of digits after the decimal point
 */
export function compactNumber(n, fractionDigits = 1) {
  const suffixes = ["", "K", "M", "B", "T"];
  const suffixNum = Math.floor((("" + parseInt(n)).length - 1) / 3);

  let shortValue = parseFloat((n / Math.pow(1000, suffixNum)).toPrecision(fractionDigits + 1));

  if (shortValue % 1 !== 0) {
    shortValue = shortValue.toFixed(fractionDigits);
  }

  return shortValue + suffixes[suffixNum];
}

export function numberWithCommas(x, fractionDigits) {
  const [naturalPart, decimalPart] = x.toString().split(".");
  let out = naturalPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (decimalPart) {
    if (!isNumeric(fractionDigits)) {
      out += "." + decimalPart;
    } else if (decimalPart.length >= fractionDigits) {
      out += "." + decimalPart.substr(0, fractionDigits);
    } else {
      out += "." + decimalPart + "0".repeat(fractionDigits - decimalPart.length);
    }
  }
  return out;
}

export function formatInteger(x) {
  let number = parseInt(x) + "";
  return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
